import classNames from 'classnames';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import EditableSection from 'components/v2/EditableSection';
import Label from 'components/v2/forms/Label';
import Select from 'components/v2/select';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const DrayageOperations = ({ data, onUpdateShipper, className }) => {
  const { t } = useTranslation();
  const [initialData, setInitialData] = useState({});
  const [drayageOpsData, setDrayageOpsData] = useState({});

  const getInitialData = () => {
    if (data) {
      setInitialData(data);
      setDrayageOpsData(data);
    }
  };

  useEffect(() => {
    getInitialData();
  }, []);

  const onChange = (field, value) => {
    setDrayageOpsData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    const updates = {};
    const { admins, ...changed } = drayageOpsData;
    Object.keys(changed).forEach((key) => {
      if (initialData[key] !== changed[key]) {
        updates[key] = changed[key];
      }
    });
    if (Object.keys(updates).length) {
      await onUpdateShipper(updates);
    }
  };

  const handleAfterSave = (onSaveSuccess) => {
    return (updatedData = {}) => {
      setInitialData((prev) => ({ ...prev, ...updatedData }));
      onSaveSuccess();
    };
  };

  return (
    <EditableSection
      title={t('DRAYAGE_OPERATIONS')}
      className={classNames(className)}
      canEdit
    >
      {(editing, saving, onSaveSuccess, onSaveFail) =>
        !editing ? (
          <DrayageOperationsSummary fields={initialData} />
        ) : (
          <DrayageOperationsForm
            fields={drayageOpsData}
            onChange={onChange}
            onSaveShipper={() => handleSave()}
            saving={saving}
            onSaveSuccess={handleAfterSave(onSaveSuccess)}
            onSaveFail={onSaveFail}
          />
        )
      }
    </EditableSection>
  );
};

const DrayageOperationsSummary = ({ fields }) => {
  const { t } = useTranslation();
  const {
    data_entry_agent,
    customer_success_west,
    customer_success_central,
    customer_success_northeast,
    customer_success_southeast,
    customer_success_exports,
  } = fields;
  const na = t('NONE');
  return (
    <div className="grid grid-cols-1 gap-4">
      <DescriptionListItem label={t('DATA_ENTRY')}>
        {data_entry_agent || na}
      </DescriptionListItem>

      <Label>{t('DRAYAGE_CUSTOMER_SUCCESS_MANAGERS')}</Label>
      <div>
        <DescriptionListItem label={t('CUSTOMER_SUCCESS_WEST')}>
          {customer_success_west || na}
        </DescriptionListItem>
      </div>
      <DescriptionListItem label={t('CUSTOMER_SUCCESS_CENTRAL')}>
        {customer_success_central || na}
      </DescriptionListItem>
      <DescriptionListItem label={t('CUSTOMER_SUCCESS_NORTHEAST')}>
        {customer_success_northeast || na}
      </DescriptionListItem>
      <DescriptionListItem label={t('CUSTOMER_SUCCESS_SOUTHEAST')}>
        {customer_success_southeast || na}
      </DescriptionListItem>
      <DescriptionListItem label={t('CUSTOMER_SUCCESS_EXPORTS')}>
        {customer_success_exports || na}
      </DescriptionListItem>
    </div>
  );
};

const DrayageOperationsForm = ({
  fields,
  onChange,
  saving,
  onSaveShipper,
  onSaveSuccess,
  onSaveFail,
}) => {
  const { t } = useTranslation();
  const saveForm = async () => {
    try {
      await onSaveShipper();
      onSaveSuccess(fields);
    } catch (e) {
      onSaveFail();
    }
  };
  useEffect(() => {
    if (saving) {
      saveForm();
    }
  }, [saving]);

  const { admins } = fields;
  return (
    <div className="grid grid-cols-1 gap-4">
      <Select
        items={admins}
        valueKey="slug"
        textKey="name"
        label={t('DATA_ENTRY')}
        info={t('DATA_ENTRY_TIP')}
        selected={fields.data_entry_agent}
        onSelect={({ slug }) => onChange('data_entry_agent', slug)}
        inputClassNames="lg:w-4/5 w-1/2"
      />

      <Label>{t('DRAYAGE_CUSTOMER_SUCCESS_MANAGERS')}</Label>

      <Select
        items={admins}
        valueKey="slug"
        textKey="name"
        label={t('CUSTOMER_SUCCESS_WEST')}
        info={t('CUSTOMER_SUCCESS_WEST_TIP')}
        selected={fields.customer_success_west}
        onSelect={({ slug }) => onChange('customer_success_west', slug)}
        inputClassNames="lg:w-4/5 w-1/2"
      />

      <Select
        items={admins}
        valueKey="slug"
        textKey="name"
        label={t('CUSTOMER_SUCCESS_CENTRAL')}
        info={t('CUSTOMER_SUCCESS_CENTRAL_TIP')}
        selected={fields.customer_success_central}
        onSelect={({ slug }) => onChange('customer_success_central', slug)}
        inputClassNames="lg:w-4/5 w-1/2"
      />

      <Select
        items={admins}
        valueKey="slug"
        textKey="name"
        label={t('CUSTOMER_SUCCESS_NORTHEAST')}
        info={t('CUSTOMER_SUCCESS_NORTHEAST_TIP')}
        selected={fields.customer_success_northeast}
        onSelect={({ slug }) => onChange('customer_success_northeast', slug)}
        inputClassNames="lg:w-4/5 w-1/2"
      />

      <Select
        items={admins}
        valueKey="slug"
        textKey="name"
        label={t('CUSTOMER_SUCCESS_SOUTHEAST')}
        info={t('CUSTOMER_SUCCESS_SOUTHEAST_TIP')}
        selected={fields.customer_success_southeast}
        onSelect={({ slug }) => onChange('customer_success_southeast', slug)}
        inputClassNames="lg:w-4/5 w-1/2"
      />

      <Select
        items={admins}
        valueKey="slug"
        textKey="name"
        label={t('CUSTOMER_SUCCESS_EXPORTS')}
        info={t('CUSTOMER_SUCCESS_EXPORTS_TIP')}
        selected={fields.customer_success_exports}
        onSelect={({ slug }) => onChange('customer_success_exports', slug)}
        inputClassNames="lg:w-4/5 w-1/2"
      />
    </div>
  );
};

export default DrayageOperations;
